import styled from 'styled-components';

import {
  mediaConfined,
  mediaSmallOrTiny,
  mediaWideNavless,
} from '@xing-com/layout-tokens';
import { spaceL, spaceM, spaceXL } from '@xing-com/tokens';

export const TertiaryArea = styled.div`
  @media ${mediaSmallOrTiny} {
    margin-top: ${spaceM};
  }

  @media (min-width: 740px) and (max-width: 1024px) {
    margin-top: ${spaceL};
  }

  @media ${mediaConfined} {
    display: flex;
  }

  @media ${mediaWideNavless} {
    margin-top: ${spaceXL};
  }
`;
export const TertiaryMainArea = styled.div`
  @media ${mediaSmallOrTiny} {
    margin-bottom: ${spaceM};
  }

  @media ${mediaConfined} {
    flex: 1;
  }
`;
export const HeaderActionsArea = styled.div`
  display: flex;
  margin-left: auto;
  justify-content: flex-end;

  @media ${mediaSmallOrTiny} {
    margin-top: ${spaceM};
  }
`;
